export default __webpack_public_path__ + "static/media/time-circle.5edbff53.svg";